import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useRecoilValue } from "recoil";
import { ortexColorState } from "@/lib/store";

interface SnackBarProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    severity?: "success" | "error" | "warning" | "info";
    text: string;
    /** A button in the alert, e.g. "Sign up" on a message that needs an account. */
    action?: { label: string; onClick: () => void };
}

const SnackBar = ({ open, setOpen, severity = "success", text, action }: SnackBarProps) => {
    const ortexColor = useRecoilValue(ortexColorState);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Snackbar open={open} onClose={handleClose} autoHideDuration={5000} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <Alert
                    onClose={handleClose}
                    severity={severity}
                    variant="filled"
                    color={severity}
                    // Alert renders `action` in place of its own close button, so an action brings
                    // the close button along with it.
                    action={
                        action && (
                            <>
                                <Button
                                    size="small"
                                    sx={{ color: "white", fontWeight: 700 }}
                                    onClick={() => {
                                        setOpen(false);
                                        action.onClick();
                                    }}
                                >
                                    {action.label}
                                </Button>
                                <IconButton size="small" aria-label="Close" onClick={handleClose}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </>
                        )
                    }
                    sx={{
                        width: "100%",
                        color: "white",
                        "& .MuiAlert-icon, & .MuiAlert-action .MuiIconButton-root": {
                            color: "white",
                        },
                        ...(severity === "success" && { backgroundColor: ortexColor }),
                    }}
                >
                    {text}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SnackBar;
